import axios from "axios";
import { SERVER_URL, APP_NAME } from "utility";
// import store from "../store/index";

const token = JSON.parse(localStorage.getItem(APP_NAME))?.auth?.token ?? "";

const axiosInstance = axios.create({
  baseURL: SERVER_URL,
  headers: {
    "Content-Type": "application/json",
    Authorization: "Bearer " + token,
  },
});

export const setAuthorizationHeader = (token) => {
  axiosInstance.defaults.headers.common.Authorization = `Bearer ${token}`;
};

export default axiosInstance;
